export default __webpack_public_path__ + "static/media/6-5.94316be1.png";